// @ts-nocheck
import { areAddressesTheSame } from "@insite/client-framework/Common/CustomerSelectors";
import { updateBillTo } from "@insite/client-framework/Services/CustomersService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import loadBillTo from "@insite/client-framework/Store/Data/BillTos/Handlers/LoadBillTo";
import loadShipTo from "@insite/client-framework/Store/Data/ShipTos/Handlers/LoadShipTo";
import {
    chain,
    UpdateBillTo,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import { BaseAddressModel } from "@insite/client-framework/Types/ApiModels";
import {
    getCarrierInfo,
    getSaveAddress,
} from "@store/Framework/Store/Store/Pages/CheckoutShipping/CheckoutShippingSelectors";
import { addToChainBefore, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const storeAreAddressesTheSame = (address1: BaseAddressModel, address2: BaseAddressModel) => {
    return (
        address1.firstName === address2.firstName &&
        address1.lastName === address2.lastName &&
        address1.attention === address2.attention &&
        address1.companyName === address2.companyName &&
        address1.address1 === address2.address1 &&
        address1.address2 === address2.address2 &&
        address1.address3 === address2.address3 &&
        address1.address4 === address2.address4 &&
        // Store Removed - Country
        address1.city === address2.city &&
        // Store Removed - State
        address1.postalCode === address2.postalCode &&
        address1.phone === address2.phone &&
        address1.email === address2.email &&
        address1.fax === address2.fax
    );
};

addToChainBefore(chain, UpdateCart, props => {
    const state = props.getState();
    const carrierInfo = getCarrierInfo(state);
    const saveAddress = getSaveAddress(state);

    // adds the carrier info to the cart's custom props
    if (carrierInfo) {
        props.apiParameter.cart = {
            ...props.apiParameter.cart,
            properties: {
                ...props.apiParameter.cart.properties,
                ...(carrierInfo?.carrierCode ? { carrierCode: carrierInfo.carrierCode } : {}),
                ...(carrierInfo?.collect ? { collectCourrier: carrierInfo.collect } : {}),
                ...(carrierInfo?.collectNumber ? { collectCourrierNumber: carrierInfo.collectNumber } : {}),
                ...(carrierInfo?.collectNumber ? { collectCourrierNumber: carrierInfo.collectNumber } : {}),
                ...(saveAddress !== undefined ? { saveAddress: saveAddress.toString() } : {}),
            },
        };
    }
});

replaceInChain(chain, UpdateBillTo, async props => {
    const { dispatch, getState, cart } = props;
    const state = getState();
    const {
        pages: {
            checkoutShipping: { billingAddressFormState },
        },
    } = state;
    if (!billingAddressFormState) {
        return;
    }

    const billTo = getBillToState(state, cart.billToId).value;
    if (!billTo) {
        throw new Error("There was no shipTo or billTo loaded for the current cart");
    }

    const { address: localModifiedBillTo } = billingAddressFormState;

    if (!storeAreAddressesTheSame(billTo, localModifiedBillTo) /* Store Custom Code */) {
        props.updatedBillTo = await updateBillTo({
            billTo: localModifiedBillTo,
            isEdit: true,
        });

        dispatch(loadBillTo({ billToId: billTo.id }));
        if (cart.shipToId === billTo.id) {
            dispatch(loadShipTo({ shipToId: cart.shipToId, billToId: billTo.id }));
        }

        props.apiParameter.cart.billToId = props.updatedBillTo.id;
    }
});
